var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCode = function SvgCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.80104002,8.88560268 L0,6.74609375 L0,5.93247768 L3.80104002,3.6875 L3.80104002,4.8828125 L1.09066245,6.31417411 L1.09066245,6.34430804 L3.80104002,7.69029018 L3.80104002,8.88560268 Z M7.94121637,2 L5.09654081,10.3973214 L4.15984566,10.3973214 L6.99231232,2 L7.94121637,2 Z M12,6.68080357 L8.19895998,8.8203125 L8.19895998,7.63002232 L10.9174768,6.2890625 L10.9174768,6.26897321 L8.19895998,4.83258929 L8.19895998,3.63727679 L12,5.8671875 L12,6.68080357 Z"
  })));
};
export default SvgCode;